import { type ComponentChildren } from 'preact';
import type { JSX } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { Spinner } from '../Spinner/spinner';
import { styles } from './button.styles';
export type ButtonVariant = 'primary' | 'ghost' | 'subtle' | 'danger' | 'dangerSolid' | 'dangerLink';
export type ButtonSize = 'md' | 'sm';
interface ButtonProps extends Omit<JSX.IntrinsicElements['button'], 'size'> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  block?: boolean;
  loading?: boolean;
  children: ComponentChildren;
}
export function Button({
  variant = 'primary',
  size = 'md',
  block = false,
  loading = false,
  children,
  disabled,
  ...rest
}: ButtonProps) {
  return <button {...rest} disabled={!!disabled || loading} aria-busy={loading || undefined} {...stylex.props(styles.base, styles[size], styles[variant], block && styles.block)}>
      {loading && <Spinner size="sm" tone="inherit" />}
      {children}
    </button>;
}